import { Form } from "react-bootstrap";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../FormGroup/FormGroup";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import "./Check.styles.css";

const Check = function Check({
  name = "",
  register = (name) => ({}),
  setValue = (name, any) => {},
  control = null,
  error = null,
  addon = null,
  label = null,
  popoverRef = (el) => ({}),
  popoverHandlers = null,
  displayAs = Form.Group,
  changeHandler = null,
  md = 6,
  withPointerOnLabel = true,
  reverseLabel = null,
  ...props
}) {
  const { ref: formRef, onChange = () => {}, ...rest } = register(name);
  return (
    <FormGroup
      controlId={name}
      addon={addon}
      error={error}
      displayAs={displayAs}
      md={md}
      className={`${
        withPointerOnLabel && "check-cursor-pointer"
      } align-items-center`}
    >
      {reverseLabel ? (
        <FormCheckLabel style={{ marginInlineEnd: "0.7rem" }}>
          {reverseLabel}
        </FormCheckLabel>
      ) : null}
      <Form.Check
        ref={(el) => {
          popoverRef(el);
          formRef && formRef(el);
        }}
        onChange={(e) => {
          onChange(e);
          if (changeHandler) changeHandler(e);
        }}
        feedback={error?.message}
        feedbackType="invalid"
        label={label}
        isInvalid={error}
        className="mb-0"
        {...popoverHandlers}
        {...rest}
        {...props}
      />
    </FormGroup>
  );
};

Check.WithPopover = withPopover(Check);
// ? Wrapping Check in memo will cause problems with react hook form (ex. reset() fn)
export default Check;
